import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-reqq-lite';
import CustomRouter from 'partial/wrappers/CustomRouter';
import store from 'setup/store';
import history from 'setup/history';
import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
// Generated by `npm run build:style` from tailwind.css — gitignored, so the
// import resolver cannot see it statically. Pre-existing; unrelated to tokens.
// eslint-disable-next-line import/no-unresolved
import 'assets/css/styles.css';
import 'assets/css/theme.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CustomRouter history={history}>
        <App />
      </CustomRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
